/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import { Box } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import * as React from "react";

const useStyles = makeStyles((theme) => ({
  content: {
    background: theme.palette.info.contrastText,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(4),
    paddingTop: theme.spacing(4) + 10,
    textAlign: "center",
    fontSize: theme.typography.h4.fontSize,
  },
  button: {
    padding: 0,
    border: 0,
    maxWidth: 110,
    maxHeight: theme.typography.h4.fontSize + 10,
  },
}));

const OverConsumedBanner = ({ show, customTopPadding }) => {
  const classes = useStyles();

  if (!show) {
    return <div></div>;
  }

  return (
    <>
      <Box
        className={classes.content}
        style={{paddingTop: customTopPadding !== undefined ? customTopPadding : classes.content.paddingTop}}
      >
        You have processed the maximum monthly limit of images and videos for your subscription. If you would like to increase your monthly limit, please contact Brighter AI.
        <br/>
        Your subscription and processing limit will be renewed at the end of the current billing period.&nbsp;
        <Button
          variant="contained"
          className={classes.button}
          href="https://brighter.ai/brighter-redact-enterprise"
        >
          CONTACT US
        </Button>
      </Box>
    </>
  );
};

export { OverConsumedBanner };
